<template>
  <div>
    <div class="row mt-4 box-users">
      <div class="col-md-6 border-right mb-3">
        <h5>Usuarios de la empresa</h5>
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            v-model="search"
            class="d-inline-block mr-1"
            placeholder="Filtrar..."
            data-cy="search-user"
          />
        </div>
      </div>
      <div class="col-md-6 border-right mb-3">
        <h5>Usuarios que recibirán los roles</h5>
      </div>
      <div class="col-md-6 border-right">
        <vs-list class="box-users">
          <div v-for="user in filteredUsers" :key="user.id">
            <vs-list-item
              :class="{ exists: isUserInGroup(user) }"
              :title="user.nombre"
              :subtitle="user.correo">
              <vs-button
                color="warning"
                v-if="!isUserInGroup(user)"
                size="small"
                type="border"
                @click="addUser(user)"
                data-cy="add-permission"
              >
                Agregar
              </vs-button>
            </vs-list-item>
          </div>
        </vs-list>
      </div>
      <div class="col-md-6">
        <vs-list class="box-users">
          <div
           v-for="user in selectedUsers"
           :key="user.id"
           data-cy="remove-permission"
           >
            <vs-list-item :title="user.nombre" :subtitle="user.correo">
              <vs-button
                color="danger"
                size="small"
                type="border"
                icon="highlight_off"
                @click="removeUser(user)"
                data-cy="remove-permission"
              />
            </vs-list-item>
          </div>
        </vs-list>
      </div>
    </div>
    <div class="mt-4 text-right">
      <b-button
        variant="primary"
        @click="saveChanges"
      >
        Guardar cambios
      </b-button>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [],
  props: {
    user: {
      type: Object,
      required: true
    },
    usersGeneral: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: '',
      selectedUsers: []
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersByGroup',
      'usersCompanyAssign'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    filteredUsers() {
      if (this.search !== '') {
        return this.usersGeneral
          .filter((user) => user.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
      }
      return this.usersGeneral;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Usuario', [
      'copyUserRoles',
    ]),
    isUserInGroup(user) {
      return (this.selectedUsers || []).find((userGroup) => userGroup.id === user.id);
    },
    removeUser(user) {
      this.selectedUsers = this.selectedUsers.filter((userSelected) => userSelected.id !== user.id);
    },
    addUser(user) {
      this.selectedUsers.push(user);
    },
    async saveChanges() {
      if (!this.selectedUsers.length) {
        this.$bvToast.toast(
          'No has agregado ningún usuario para recibir roles',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      const selectedUsersIds = this.selectedUsers.map((userMap) => userMap.id);
      await this.copyUserRoles(
        { userId: this.user.id, selectedUsers: selectedUsersIds }
      );
      await this.$bvToast.toast(
        'Se ha realizado la acción correctamente',
        {
          title: 'Genial',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.$emit('close-action');
    }
  }
};
</script>
<style scoped>

.box-users {
  height: 500px;
  overflow-y: auto;
}
.con-vs-popup .vs-popup {
  width: 70% !important;
}
.exists {
  color: #671e85;
  background: #671e852b;
  border-radius: 4px;
  margin-top: 2px;
}
</style>
